import { FieldLabel } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function ExplodeInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Array column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Empty arrays</FieldLabel>
      <Segmented value={c.empty || 'drop'} onChange={(v) => u({ empty: v })}
        options={[
          { value: 'drop', label: 'Drop row' },
          { value: 'keep', label: 'Keep with null' },
        ]} />
    </div>
  );
}
